import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'
import { cn } from '@/shared/lib/utils'

export type PricingModel = 'flat' | 'tiered' | 'volume' | 'package'

interface PricingModelSelectProps {
  value: PricingModel
  onValueChange: (value: PricingModel) => void
  className?: string
  placeholder?: string
}

export function PricingModelSelect({
  value,
  onValueChange,
  className,
  placeholder = 'Select pricing model',
}: PricingModelSelectProps) {
  const getSelectedDisplay = () => {
    switch (value) {
      case 'flat':
        return 'Flat Rate'
      case 'package':
        return 'Package'
      case 'volume':
        return 'Volume'
      case 'tiered':
        return 'Tiered'
      default:
        return placeholder
    }
  }

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={cn('mt-3', className)}>
        <SelectValue>{value ? getSelectedDisplay() : placeholder}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='flat'>
          <div className='py-1'>
            <div className='font-medium'>Flat Rate</div>
            <div className='text-xs text-muted-foreground'>
              Customers pay same price per unit
            </div>
          </div>
        </SelectItem>
        <SelectItem value='package'>
          <div className='py-1'>
            <div className='font-medium'>Package</div>
            <div className='text-xs text-muted-foreground'>
              Customer purchase blocks of units
            </div>
          </div>
        </SelectItem>
        <SelectItem value='volume'>
          <div className='py-1'>
            <div className='font-medium'>Volume</div>
            <div className='text-xs text-muted-foreground'>
              Customers pay per unit, price based on final tier reached
            </div>
          </div>
        </SelectItem>
        <SelectItem value='tiered'>
          <div className='py-1'>
            <div className='font-medium'>Tiered</div>
            <div className='text-xs text-muted-foreground'>
              Customers pay per unit, tiers apply progressively as quantity
              increases
            </div>
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  )
}
